import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import '../reportStyles.scss';
import { CustomButton, Text } from '../../../shared/uiComponents';
import { errorNormalizer } from '../../../shared/Helpers/functions';
import { ReportFilters, downloadFile } from '../helpers';
import { REPORT_GENERATION_MESSAGE } from '../../../shared/Helpers/constants';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getElcSessionReport } from '../../../redux/State/clientSlice/excelReport';

const ElcAttendanceReport = () => {
	const dispatch = useDispatch<DispatchProperties>();

	const filterData = useSelector((state) => state.billing.billingFilters);
	const loading = useSelector((state) => state.excelReport.loading);

	const downloadHandler = useCallback(() => {
		const { clientId, endDate, startDate, userId } = filterData;

		toast(REPORT_GENERATION_MESSAGE);

		dispatch(
			getElcSessionReport({
				userId,
				clientId,
				startDate,
				endDate,
			}),
		)
			.then(unwrapResult)
			.then((response) => downloadFile(response))
			.catch(errorNormalizer);
	}, [dispatch, filterData]);

	return (
		<>
			<Text title="ELC Attendance Report" type="h6" fontWeight="semiBold" className="marginBottom16" />
			<ReportFilters showUsers={false} showOnlyNew={false} />
			<div style={{ width: 'max-content' }} className="marginTop16">
				<CustomButton title="Download" onClick={downloadHandler} loading={loading} disabled={filterData.timeError} />
			</div>
		</>
	);
};

export default ElcAttendanceReport;
